import { shouldFireMedPixel } from "src/utils/userSegment/features";
import { registerHandler, Sha256Email } from "../handler";
import { MedProductType } from "src/utils/constants";
import { generateEventId } from "../utils";
import { LibCategories, waitForConsent } from "src/utils/consent";
import { getURLParams } from "src/utils/urlParams";

declare const snaptr: any;

const NOOM_MED_SNAPCHAT_PIXEL = "69c5a9b1-9efd-4f96-808f-7d7d85efdb47";
const NOOM_WEIGHT_SNAPCHAT_PIXEL = "e030eb4f-d3fd-4c13-9338-9c0a3b6847ad";

const LOCAL_STORAGE_CLICK_ID_KEY = "snapchatClickId";

function getSnapchatPixelId() {
  if (shouldFireMedPixel()) {
    return NOOM_MED_SNAPCHAT_PIXEL;
  }
  return NOOM_WEIGHT_SNAPCHAT_PIXEL;
}

function getClickId() {
  return (
    getURLParams().ScCid ||
    getURLParams().scCid ||
    localStorage.getItem(LOCAL_STORAGE_CLICK_ID_KEY)
  );
}

function initSnap(clickId: string, email?: Sha256Email) {
  snaptr("init", getSnapchatPixelId(), {
    ...(email ? { user_hashed_email: email } : {}),
    ...(clickId ? { sscid: clickId } : {}),
  });
  if (clickId && clickId !== localStorage.getItem(LOCAL_STORAGE_CLICK_ID_KEY)) {
    waitForConsent([LibCategories.targetingCookies]).then(() => {
      localStorage.setItem(LOCAL_STORAGE_CLICK_ID_KEY, clickId);
    });
  }
}

export default function registerHandlers() {
  registerHandler("init", () => {
    const clickId = getClickId();
    initSnap(clickId);
    snaptr("track", "PAGE_VIEW", {
      ...(clickId ? { sscid: clickId } : {}),
    });
  });

  registerHandler("purchase", ({ emailHashes, order, plan }) => {
    const clickId = getClickId();
    initSnap(clickId, emailHashes.sha256);

    snaptr("track", "SIGN_UP", {
      user_hashed_email: emailHashes.sha256,
      currency: plan.currency || "USD",
      transaction_id: order.subscriptionId,
      price: order.eltv_13_months,
      ...(clickId ? { sscid: clickId } : {}),
    });
  });

  registerHandler(
    "purchaseIntent",
    ({ emailHashes, medProductType, plan, estimatedValue, userId }) => {
      if (medProductType !== MedProductType.HRT) {
        const clickId = getClickId();
        initSnap(clickId, emailHashes.sha256);
        snaptr("track", "SIGN_UP", {
          user_hashed_email: emailHashes.sha256,
          currency: plan.currency || "USD",
          transaction_id: generateEventId(userId),
          price: estimatedValue,
          ...(clickId ? { sscid: clickId } : {}),
        });
      }
    }
  );
}
